<template>
  <transition name="fade">
    <div class="modal_info" v-show="showInfoModal">
        <div class="modal_info-container">
          <div class="container">
            <div class="modal_info-body">
              <p><strong>Уважаемый пользователь</strong>! Отключите пожалуйста <b>AdBlock</b> или подобное расширение, для стабильной работы онлайн записи.</p>
              <button @click="showInfoModal = false" class="modal_info__action-btn">Хорошо</button>
            </div>
          </div>
      </div>
    </div>
  </transition>
</template>
<script>
  export default {
    name: "addBlockerChecker",
    data() {
      return {
        showInfoModal: false
      }
    },
    methods: {
      blockerCheck() {
        return new Promise((resolve, reject) => {
          const element = document.createElement("div");
          element.classList.add('adBanner');
          element.style.cssText = 'height: 1px; width: 1px; background-color: transparent';
          document.body.appendChild(element);
          window.setTimeout(()=>{
            if(document.querySelector('.adBanner').clientHeight === 0){
              resolve(true)
            }else{
              resolve(false)
            }
            document.body.removeChild(element);
          }, 20)
        })
      }
    },
    created() {
      this.blockerCheck().then((response) => {
        setTimeout(()=> {
          this.showInfoModal =  !!response
        },4000)
      });
    }
  }
</script>

<style scoped lang="sass">
  .modal_info
    &-body
      display: flex
      justify-content: flex-start
      flex-wrap: wrap
      align-items: center
      padding: 8px 0
      p
        margin: 0
        line-height: 1.6
        font-size: 12px
        text-align: justify
    &-container
      background: #f8f8f8
      box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3)
    &__action-btn
      display: block
      font-size: 12px
      text-align: center
      padding: 4px 15px
      color: #fff
      border-radius: 8px
      background-color: #363636
      border: 1px solid transparent
      cursor: pointer
      margin: 0 auto
  .fade-enter-active, .fade-leave-active
    transition: opacity .4s
  .fade-enter, .fade-leave-to
    opacity: 0

</style>
